import { IExtendedSearchData } from "src/api/server/extended-search.types";
import { useSearchRequestParams } from "src/components/pages/search/hooks/use-search-request-params";
import { ResultSection } from "src/components/pages/search/result-section";
import { SearchRefinementSection } from "src/components/pages/search/search-refinement-section";
import { ErrorBoundary } from "src/components-mui/common/error-boundary/error-boundary";
import { Container } from "src/components-mui/layout/container";

interface ISearchPageContentProps {
    data: IExtendedSearchData;
}

export const SearchPageContent = ({ data }: ISearchPageContentProps) => {
    const searchParams = useSearchRequestParams();

    return (
        <>
            <ErrorBoundary>
                <SearchRefinementSection data={data} searchParams={searchParams} />
            </ErrorBoundary>
            <Container component="section" sx={{ mb: { xs: 7, sm: 10 } }}>
                <ErrorBoundary>
                    <ResultSection searchParams={searchParams} figuresPicker={data.figuresPicker} />
                </ErrorBoundary>
            </Container>
        </>
    );
};
